export {
  PageContextProvider,
  PageContextConsumer,
  usePageContext,
} from '@wix/bex-core/react';
